import React, { useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Collapse } from 'react-bootstrap';
import axios from 'axios';
import Form from "../Form/Form";
import FormMobile from "../Form/FormMobile";
import ButtonList from "../ButtonList/ButtonList";



function OurFacility() {

    const [open, setOpen] = useState(false);

    const [open1, setOpen1] = useState(false);


    return (
        <>



            <section id="club_fitting" className="club_fitting bg_white page-section">
                <div className="container-xl">
                    <div className="d-flex align-items-center justify-content-between sec_tile_bar">
                        <div className="">
                            <h2 className="sec_title title_dark">Our Approach</h2>
                        </div>
                        <div className="btn-section hide_mobile">
                            <ButtonList subject = "about us" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="card hide_mobile">
                                <div className="card-body">
                                    <h4 className="card-title">Need assistance?</h4>
                                    <Form subject="about us" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            {/* <div className="video_card"> */}
                            {/* <Swiper
                                modules={[Navigation]}
                                navigation
                                spaceBetween={50}
                                slidesPerView={1}
                                onSlideChange={() => console.log('slide change')}
                                onSwiper={(swiper) => console.log(swiper)}
                                className="swiper mySwiper_img"
                            >
                                <SwiperSlide>
                                    <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: '100%', width: '100%' }}>01</h1>
                                    <img src={require('../../assets/images/thumb_video.jpg')} className="card-radius w-100" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: '100%', width: '100%' }}>02</h1>
                                    <img src={require('../../assets/images/thumb_video.jpg')} className="card-radius w-100" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: '100%', width: '100%' }}>03</h1>
                                    <img src={require('../../assets/images/thumb_video.jpg')} className="card-radius w-100" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: '100%', width: '100%' }}>04</h1>
                                    <img src={require('../../assets/images/thumb_video.jpg')} className="card-radius w-100" />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <h1 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', height: '100%', width: '100%' }}>05</h1>
                                    <img src={require('../../assets/images/thumb_video.jpg')} className="card-radius w-100" />
                                </SwiperSlide>
                            </Swiper> */}
                            <div className="ifream-video-box ratio ratio-16x9 iframe_wrapper">
                                <div id="v-video" className="v-video">
                                    <iframe src="https://player.vimeo.com/video/898469279?h=b2407d1914&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;controls=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} title="JuniorLandingEnrollConfirmation" data-ready="true"></iframe>
                                </div>
                            </div>
                            {/* </div> */}
                            <div className="row">
                                <div className="col-lg-6 accordion-item acc_items">
                                    <div className="points_sec">
                                        <h4 className="custom-collapse" id="fitter_p1">
                                            <span className="collapsed" onClick={() => setOpen(!open)} aria-controls="example-collapse-text" aria-expanded={open}>
                                                Expert Professionals
                                                <img className="hide_desktop" src={require('../../assets/images/angle_down.png')} />
                                            </span>
                                        </h4>
                                        <Collapse in={open}>
                                            <p id="fitter_pc1" className="accordion-collapse collapse" aria-labelledby="fitter_p1">
                                                Our fitters and instructors are not just respected locally, they are recognized industry wide. We treat every client like a touring professional.
                                            </p>
                                        </Collapse>
                                    </div>
                                </div>
                                <div className="col-lg-6 accordion-item acc_items">
                                    <div className="points_sec">
                                        <h4 className="custom-collapse" id="fitter_p2">
                                            <span className="collapsed" onClick={() => setOpen1(!open1)} aria-controls="example-collapse-text" aria-expanded={open1}>
                                                State of the art tech
                                                <img className="hide_desktop" src={require('../../assets/images/angle_down.png')} />
                                            </span>
                                        </h4>
                                        <Collapse in={open1}>
                                            <p id="fitter_pc2" className="accordion-collapse collapse" aria-labelledby="fitter_p2">
                                                We utilize the best technology in the industry in our facility such as Foresight, Quintech, Flightscope, Swing Catalyst and more.
                                            </p>
                                        </Collapse>
                                    </div>
                                </div>
                            </div>
                            <div className="card show_mobile">
                                <div className="card-body">
                                    <h4 className="card-title">Need assistance?</h4>
                                    <FormMobile subject="about us" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
}

export default OurFacility;